import {
    CasesGeneralInformation,
    CasesGeneralInformationFilter,
} from '../shared/types/modules/cases-general-information';
import { apiService } from './index';

export const asyncGetCasesGeneralInformations = async (
    filters: CasesGeneralInformationFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: CasesGeneralInformation[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: CasesGeneralInformation[]; length: number };
        } = await apiService.get('/api/cases-general-information', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetCasesGeneralInformation = async (
    idCasesGeneralInformation: string
): Promise<CasesGeneralInformation | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: CasesGeneralInformation;
        } = await apiService.get(
            `/api/cases-general-information/${idCasesGeneralInformation}`
        );

        return data;
    } catch (error) {}
};

export const asyncCreateCasesGeneralInformation = async (
    info: CasesGeneralInformation
): Promise<CasesGeneralInformation | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: CasesGeneralInformation;
        } = await apiService.post('/api/cases-general-information', info);

        return data;
    } catch (error) {}
};

export const asyncUpdateCasesGeneralInformation = async (
    id: string,
    info: CasesGeneralInformation
): Promise<CasesGeneralInformation | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: CasesGeneralInformation;
        } = await apiService.patch(
            `/api/cases-general-information/${id}`,
            info
        );

        return data;
    } catch (error) {}
};
